var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayList2Line = function SvgPlayList2Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.5 17.402v1.8h-18v-1.8zm-18-13.05 7.2 4.5-7.2 4.5zm18 6.75v1.8h-9v-1.8zM5.3 7.599v2.505l2.003-1.252zm16.2-2.797v1.8h-9v-1.8z"
  })));
};
export default SvgPlayList2Line;